import React, { useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { QuestionResultsProps } from "./interfaces";
import * as echarts from 'echarts';
import {
    DEFCON9,
    DEFCON7,
    DEFCON5,
    DEFCON4,
    DEFCON3,
    DEFCON2,
    DEFCON1,
} from "./debug.json";

const QuestionResult = (props: QuestionResultsProps) => {
    const { data: question } = props;

    const legendData = question?.options?.nodes?.map(option => {
        return option?.content || "???";
    });

    //first fix tht total
    let total = 0;
    var seriesData = question?.options?.nodes?.map(option => {
        let value = option?.responses?.totalCount || 0;
        total = total + value;
        return value;
    });

    var seriesDataOfTotal = seriesData.map(data => {
        let value = ((data / total) * 100).toFixed(2);
        return value;
    });




    //const [chartData, setChartData] = useState(mappedData);

    if (!question) {
        return null;
    }
    DEFCON3 && console.log('Legend data');
    DEFCON3 && console.log(legendData);

    DEFCON3 && console.log('Data');
    DEFCON3 && console.log(seriesData);

    DEFCON3 && console.log('Data in %');
    DEFCON3 && console.log(seriesDataOfTotal);

    const option = {
      xAxis: {
        type: "category",
        data: legendData,
        axisLabel: {
          inside: false,
          color: "#fff",
          rotate: 45,
          fontSize: 12,
        },
      },
      yAxis: {
        type: "value",
        axisLabel: {
          color: "#fff",
          formatter: "{value}%",
          margin: 0,
          fontSize: 8,
        },
        min: 0,
        max: 100,
      },
      series: [
        {
          data: seriesDataOfTotal,
          type: "bar",
          showBackground: true,
          backgroundStyle: {
            color: "rgba(180, 180, 180, 0.2)",
          },
          // label: {
          //     show: true,
          //     position: 'inside'
          // },
          itemStyle: {
            opacity: 0.8,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#BB4A98" },
              { offset: 0.5, color: "#C44FC6" },
              { offset: 1, color: "#DD5888" },
            ]),
          },
          emphasis: {
            itemStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#DD5888" },
                { offset: 0.7, color: "#C44FC6" },
                { offset: 1, color: "#BB4A98" },
              ]),
            },
          },
        },
      ],
    };


    return <ReactECharts
        option={option}
        style={{  }}
    />;
};

export default QuestionResult;